import {
    FETCH_SEND_SMS_PAGE,
    FETCH_CHECK_SMS_PAGE,
    FETCH_PAYMENT_BY_TOKEN_PAGE,
    STEP_SEND_SMS,
    STEP_CHECK_SMS,
    FETCH_SET_ACCESS_TOKEN,
    FETCH_LOAN_INFO_PAGE,
    STEP_LOAN_INFO,
    FETCH_PAYMENT_PAGE,
    STEP_PAYMENT_PAGE,
    STEP_PAYMENT_BY_TOKEN,
} from "../actions";

const updateApp = (state, action) => {
    const initialState = {
        data: {
            accessToken: '',
            backUrl: 'https://airbapay.kz/',
            step: STEP_SEND_SMS,
            fromSite: true,
        },
    }
    if (state === undefined) {
        return initialState;
    }
    console.log(action.type)
    console.log(action.payload)
    switch (action.type) {
        case FETCH_SEND_SMS_PAGE:
            return initialState
        case FETCH_CHECK_SMS_PAGE:
            return {
                data:{
                    ...initialState.data,
                    step: STEP_CHECK_SMS,
                },
            }
        case FETCH_SET_ACCESS_TOKEN:
            return {
                data: {
                    ...state.app.data,
                    accessToken: action.payload
                },
            }
        case FETCH_PAYMENT_BY_TOKEN_PAGE:
            return {
                data: {
                    accessToken: action.payload.accessToken,
                    backUrl: action.payload.backUrl,
                    step: STEP_PAYMENT_BY_TOKEN,
                    fromSite: false,
                },
            }
        case FETCH_LOAN_INFO_PAGE:
            return {
                data:{
                    ...state.app.data,
                    step: STEP_LOAN_INFO,
                },
            }
        case FETCH_PAYMENT_PAGE:
            return {
                data:{
                    ...state.app.data,
                    step: STEP_PAYMENT_PAGE,
                },
            }
        default:
            return state.app
    }
}
export default updateApp;